<template>
    <div>
        <PageHeaderUI title="Shipment Timeline" breadcrumb="Dashboard > Bookings & Shipments  > Trackings" />
        <DispatchTimeline />
    </div>
</template>

<script>
import DispatchTimeline from "@/components/3pl/Operations/Dispatch/dispatch-timeline.vue";
import PageHeaderUI from "@/components/Ondemand/UI/PageHeaderUI.vue";
export default {
    components: {
        DispatchTimeline,
        PageHeaderUI
    },
};
</script>

<style></style>
